import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../../../shared/configurations/configurations.factory';
import { Configurations } from '../../../shared/configurations/models/configurations.model';
import { ApiEnumerationModel } from '../DTOs/base-DTOs/api-enumeration-model.dto';
import { LeadConfigAuditCategoryDto } from '../DTOs/lead-audit.dto';
import { UserConfigPermissionDto } from '../DTOs/user-config-permission.dto';
import { UserConfigPropertyDto } from '../DTOs/user-config-property.dto';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: HttpClient) {
    this.baseUrl = config.environmentConfig.lobbyBaseUrl + '/config'
  }

  getUserPropertiesConfigurations$(): Observable<ApiEnumerationModel<UserConfigPropertyDto>> {
    return this.httpClient.get<ApiEnumerationModel<UserConfigPropertyDto>>(this.baseUrl + `/user/properties`)
  }

  getUserPermissionsConfigurations$(): Observable<ApiEnumerationModel<UserConfigPermissionDto>> {
    return this.httpClient.get<ApiEnumerationModel<UserConfigPermissionDto>>(this.baseUrl + `/user/permissions`)
  }

  getUserPermissionsConfigurationsByRole$(role: string): Observable<ApiEnumerationModel<UserConfigPermissionDto>> {
    return this.httpClient.get<ApiEnumerationModel<UserConfigPermissionDto>>(this.baseUrl + `/user/role/${role}/permissions`)
  }

  getLeadAuditCategories$(): Observable<ApiEnumerationModel<LeadConfigAuditCategoryDto>> {
    return this.httpClient.get<ApiEnumerationModel<LeadConfigAuditCategoryDto>>(this.baseUrl + `/lead/audit/category`)
  }
}
